import { defineStore } from 'pinia'
import { computed } from 'vue'
import { useNFTContractAPIStore } from '@/stores'
import { NftContract } from '@/types'

export const useNFTContractStore = defineStore('nftContract', () => {
  const nftContractAPIStore = useNFTContractAPIStore()
  const nftContractList = computed(() => {
    return nftContractAPIStore.contractList?.map((contract) => {
      return new NftContract(contract)
    })
  })

  const getNFTContract = (id: number) => {
    return nftContractList.value?.find((contract) => contract.id === id)
  }
  return {
    nftContractList,
    getNFTContract,
  }
})
